<script setup lang="ts">
/**
 * Singbac — NON NOMINEE Notice (Section 386AL(1) 통지 · 명목이사 아님).
 * per client-director (DocScope dir_{id}/). 체크박스는 문서 고정값.
 * 지명자(nominator) 상세는 전부 리터럴 "Not Applicable" (변수 아님).
 */
import CddVarField from './cdd/CddVarField.vue';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <p class="doc-p"><CddVarField field-key="client_name" label="Client Name" /></p>
    <p class="doc-p"><CddVarField field-key="client_address" label="Client Address" /></p>
    <p class="doc-p"><b>Date:</b> <CddVarField field-key="notice_date" label="Notice Date" /></p>

    <p class="doc-p">
      The Board of Directors<br />
      <CddVarField field-key="company_name" label="Company Name" /> (the "Company")<br />
      <CddVarField field-key="registered_office_address" label="Registered Office Address" />
    </p>

    <p class="doc-p">Dear Sirs,</p>

    <div class="doc-sec-title">NOTIFICATION PURSUANT TO SECTION 386AL(1) OF THE COMPANIES ACT 1967</div>
    <p class="doc-lbl-title" style="text-align:center">APPOINTMENT AS NOMINEE DIRECTOR</p>

    <p class="doc-p">In compliance with Section 386AL(1) of the Companies Act 1967, I hereby confirm that:</p>

    <p class="doc-p"><span class="cbx">☒</span> I am not acting as a nominee director in the Company.</p>
    <p class="doc-p"><span class="cbx">☐</span> I have been appointed as a nominee director in the Company by the following nominator:</p>

    <p class="doc-lbl-title">Particulars of Nominator (Corporate)</p>
    <table class="cdd-tbl">
      <tbody>
        <tr><td>Full name of corporate nominator</td><td>Not Applicable</td></tr>
        <tr><td>Unique entity number of corporate nominator issued by the Registrar, if any</td><td>Not Applicable</td></tr>
        <tr><td>Address of registered office of corporate nominator</td><td>Not Applicable</td></tr>
        <tr><td>Email address of corporate nominator (New)</td><td>Not Applicable</td></tr>
        <tr><td>Contact number of corporate nominator (New)</td><td>Country code / Area code / Number</td></tr>
        <tr><td>Legal form of corporate nominator</td><td>Not Applicable</td></tr>
        <tr><td>Jurisdiction where corporate nominator is formed/incorporated</td><td>Not Applicable</td></tr>
        <tr><td>Statute under which corporate nominator is formed/incorporated</td><td>Not Applicable</td></tr>
        <tr><td>Name of the corporate entity register of the jurisdiction in which corporate nominator is formed/incorporated</td><td>Not Applicable</td></tr>
        <tr><td>Identification/registration number of corporate nominator on the corporate entity register of the jurisdiction where the corporate nominator is formed/incorporated</td><td>Not Applicable</td></tr>
        <tr><td>Date on which I became corporate nominator's nominee</td><td>Not Applicable</td></tr>
      </tbody>
    </table>

    <p class="doc-lbl-title">Particulars of Nominator (Individual)</p>
    <table class="cdd-tbl">
      <tbody>
        <tr><td>Full name of individual nominator</td><td>Not Applicable</td></tr>
        <tr><td>Aliases, if any, of individual nominator</td><td>Not Applicable</td></tr>
        <tr><td>Residential address of individual nominator</td><td>Not Applicable</td></tr>
        <tr><td>Email address of individual nominator (New)</td><td>Not Applicable</td></tr>
        <tr><td>Contact number of individual nominator (New)</td><td>Country code / Area code / Number</td></tr>
        <tr><td>Nationality of individual nominator</td><td>Not Applicable</td></tr>
        <tr><td>Identity card number or passport number of individual nominator</td><td>Not Applicable</td></tr>
        <tr><td>Date of birth of individual nominator</td><td>Not Applicable</td></tr>
        <tr><td>Date on which I became individual nominator's nominee</td><td>Not Applicable</td></tr>
      </tbody>
    </table>

    <p class="doc-p">Please make the necessary entries into the Register of Nominee Directors of the Company.</p>

    <p class="doc-p">Yours faithfully</p>
    <div class="sig-line">______________________</div>
    <p class="doc-p"><CddVarField field-key="client_name" label="Client Name" /></p>

    <p class="doc-lbl-title">Notes</p>
    <p class="doc-p">
      A director is a nominee if the director is accustomed or under an obligation whether formal or informal to act in
      accordance with the directions, instructions or wishes of any other person.
    </p>
    <p class="doc-p">
      The obligation to act in accordance with the directions, instructions or wishes of any other person may arise from
      legal obligations (e.g. contract; trust) or informal arrangements.
    </p>
    <p class="doc-p">
      For example, a director is a nominee of a person with a shareholding in the company if he is appointed by that
      person to the board of directors of the company and he acts in accordance with the directions, instructions or
      wishes of that person.
    </p>
  </div>
</template>

<style scoped>
.doc-lbl-title { font-weight: 800; margin: 14px 0 6px; }
.cbx { font-size: 15px; margin-right: 6px; }
.sig-line { font-family: monospace; margin-top: 18px; }
</style>
